import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EReplyStatus } from 'src/app/models/recipients.model';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';

// Reports tab "סטטוס טופס" filter. Modelled on MlmExportStatusFilterComponent (same multi-select
// checkbox list + NG_VALUE_ACCESSOR wiring); the options are the request-level statuses the Reports
// screen covers, which is exactly what the server's ReportFormStatuses whitelist admits.
@Component({
  selector: 'que-form-status-filter',
  imports: [CommonModule, TranslateDirective],
  templateUrl: './form-status-filter.component.html',
  styleUrls: ['./form-status-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: FormStatusFilterComponent, multi: true }]
})
export class FormStatusFilterComponent implements OnInit {
  enumReplyStatus = EReplyStatus;
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  statusList = [
    {
      status: EReplyStatus.Approved,
      choosed: false
    },
    {
      status: EReplyStatus.PendingApproval,
      choosed: false
    },
    {
      status: EReplyStatus.Rejected,
      choosed: false
    },
  ];

  ngOnInit() {
    this.statusList.map(x => this.selectedFilter$()?.formStatus?.includes(x.status) ? x.choosed = true : false)
  }

  valueControl = new FormControl<EReplyStatus[] | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: any): void {
    this.valueControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
  }

  selectStatus(item: any) {
    item.choosed = !item.choosed;
    const itemsSelected = this.statusList.filter(x => x.choosed == true).map(x => { return x.status });
    this.valueControl.setValue(itemsSelected);
    if (this.callBackFunction) {
      this.callBackFunction(this.valueControl.value);
    }
  }
}
